
export const METHOD_MODE_ESTIMATE = 1
export const METHOD_MODE_SIGN = 2
export const METHOD_MODE_SIGN_AND_SEND = 3
